import {greenColor, redColor} from '../../cmsMainStyle'

const circulationReplyFormStyle = theme => ({

	read: {
		color: greenColor[5]
	},

	unread: {
		color: redColor[5]
	}

	// root: {
	// 	height: window.outerHeight - (window.outerHeight - window.innerHeight + 140),
	// 	overflowY: "auto",
	// 	overflowX: "hidden",
	// },

	// addFileBtnArea: {
	// 	textAlign: "center",
	// 	paddingTop: theme.spacing(1),
	// 	paddingBottom: theme.spacing(1),
	// },

	// messageRecipientArea: {
	// 	'& > *': {
	// 		margin: theme.spacing(0.5),
	// 	  },
	// },

	// addFileBtn: {
	// 	background: DodgerBlueColor[11],
	// 	'&:hover': {
	// 		background: DodgerBlueColor[13],
	// 	},

	// 	marginTop: theme.spacing(1),
	// 	marginLeft: theme.spacing(1),
	// 	marginRight: theme.spacing(1),
	// },

	// subjectArea: {
	// 	paddingTop: theme.spacing(2),
	// },

	// editorArea: {
	// 	paddingTop: theme.spacing(2),
	// 	paddingBottom: theme.spacing(2),
	// },

	// btnArea: {
	// 	paddingTop: theme.spacing(2),
	// 	paddingBottom: theme.spacing(2),
	// },




	// messageCode: {
	// 	paddingTop: theme.spacing(1),
	// 	paddingLeft: theme.spacing(2),
	// 	paddingRight: theme.spacing(2)
	// },

	// messageSubject: {
	// 	paddingLeft: theme.spacing(2),
	// 	paddingRight: theme.spacing(2)
	// },

	// errorMsg: {
	// 	marginTop: theme.spacing(0.5),
	// 	marginLeft: theme.spacing(2)
	// },

	// divider: {
	// 	marginBottom: theme.spacing(2)
	// }
})

export default circulationReplyFormStyle